import React, { useState, useEffect } from 'react';
import { Panel } from 'primereact/panel';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputTextarea } from 'primereact/inputtextarea';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { travelService } from '../../services/extensions';
import { userTravelRecords } from '../../services/common/states';
import { useNavigate } from 'react-router';
import { useFormik } from 'formik';
import { classNames } from 'primereact/utils';
import { setTravelTab } from '../../services/store/userSlice';
import { useDispatch } from 'react-redux';
import TravelDataTable from './travel-datatable';

const TravellerDetails = () => {
    const dispatch = useDispatch();
    const [tripTypes, setTripTypes] = useState([]);
    const navigate = useNavigate();
    const [visaTypes, setVisaTypes] = useState([]);
    const [designation, setDesignation] = useState([]);
    const [travellerFormSubmit, setTravellerFormSubmit] = useState(false);
    var currentUser = JSON.parse(localStorage.getItem("user"));

    useEffect(() => {
        console.log(currentUser, "currentUsercurrentUser")
        getAllTripTypes()
        getAllVisaTypes()
        GetAllDesignation()
        userTravelRecords.subscribe((result) => {
            if (result) {
                console.log("Result Value", result)
                searchForm.setFieldValue("userecn", currentUser.ecn ? currentUser.ecn : result.userecn);
                searchForm.setFieldValue("managerecn", currentUser?.superior?.ecn ? currentUser?.superior?.ecn : result.managerecn);
                searchForm.setFieldValue("travellercomment", result.travellercomment);
                searchForm.setFieldValue("selectedTripType", result.selectedTripType);
                searchForm.setFieldValue("selectedVisaType", result.selectedVisaType);
                searchForm.setFieldValue("selectedDesignation", result.selectedDesignation);
                searchForm.setFieldValue("surname", currentUser?.lastName ? currentUser?.lastName : result.surname);
                searchForm.setFieldValue("givenName", currentUser?.firstName ? localStorage.getItem('travellerName') || (currentUser?.firstName || "") + " " + (currentUser?.lastName || "") : result.givenName);
                searchForm.setFieldValue("mobileNumber", currentUser?.phone ? currentUser?.phone : result.mobileNumber);
                searchForm.setFieldValue("emailId", currentUser?.email ? currentUser?.email : result.emailId);
                searchForm.setFieldValue("Grade", result.Grade);
                searchForm.setFieldValue("travellerInitiatedBy", currentUser?.superior?.firstName ? (currentUser?.superior?.firstName || "") + " " + (currentUser?.superior?.lastName || "") : result.travellerInitiatedBy);
                searchForm.setFieldValue("travellerName", currentUser?.firstName ? localStorage.getItem('travellerName') || (currentUser?.firstName || "") + " " + (currentUser?.lastName || "") : result.travellerName);
            }
        });
    }, []);
    const getAllTripTypes = () => {
        travelService.GetAlltripType()
            .then(response => {
                if (response.data.success) {
                    const options = response.data.data.map(trip => ({
                        label: trip.title,
                        value: trip.id
                    }));
                    setTripTypes(options);
                }
            })
            .catch(error => {
                console.error('Error fetching trip types:', error);
            });
    };
    //visa
    const getAllVisaTypes = () => {
        travelService.GetAllVisaType()
            .then(response => {
                if (response.data.success) {
                    const options = response.data.data.map(visa => ({
                        label: visa.title,
                        value: visa.id
                    }));
                    setVisaTypes(options);
                }
            })
            .catch(error => {
                console.error('Error fetching visa types:', error);
            });
    };
    //designation
    const GetAllDesignation = () => {
        travelService.GetAllDesignation()
            .then(response => {
                if (response.data.success) {
                    const options = response.data.data.map(designation => ({
                        label: designation.title,
                        value: designation.id
                    }));
                    setDesignation(options);
                }
            })
            .catch(error => {
                console.error('Error fetching designation types:', error);
            });
    };

    const searchForm = useFormik({
        initialValues: {
            selectedTripType: null,
            selectedVisaType: null,
            selectedDesignation: currentUser?.Designation || '',
            travellerName: localStorage.getItem('travellerName') || (currentUser?.firstName || "") + " " + (currentUser?.lastName || ""),
            travellerInitiatedBy: (currentUser?.superior?.firstName || "") + " " + (currentUser?.superior?.lastName || ""),
            surname: currentUser?.lastName || '',
            givenName: localStorage.getItem('travellerName') || (currentUser?.firstName || "") + " " + (currentUser?.lastName || ""),
            mobileNumber: currentUser?.phone || '',
            emailId: currentUser?.email || '',
            travellercomment: '',
            userecn: currentUser?.ecn || '',
            managerecn: currentUser?.superior?.ecn || '',
            Grade: '',
        },
        validate: (data) => {
            console.log(data, "Validate Data", travellerFormSubmit)
            if (travellerFormSubmit) {
                let errors = {};
                if (!data.selectedTripType) {
                    errors.selectedTripType = 'Select Trip Type';
                }
                if (!data.selectedVisaType) {
                    errors.selectedVisaType = 'Select Visa Type';
                }
                if (!data.userecn) {
                    errors.userecn = 'Enter User ECN';
                }

                if (!data.managerecn) {
                    errors.managerecn = 'Enter Manager ECN';
                }
                if (!data.travellerName) {
                    errors.travellerName = 'Enter Traveller Name';
                }
                if (!data.travellerInitiatedBy) {
                    errors.travellerInitiatedBy = 'Enter Traveller Initiated By';
                }
                if (!data.surname) {
                    errors.surname = 'Enter Surname';
                }
                if (!data.givenName) {
                    errors.givenName = 'Enter GivenName';
                }
                if (!data.selectedDesignation) {
                    errors.selectedDesignation = 'Select Designation';
                }
                if (!data.mobileNumber) {
                    errors.mobileNumber = 'Enter Mobile Number';
                }
                if (!data.emailId) {
                    errors.emailId = 'Enter Email ID';
                }
                if (!data.Grade) {
                    errors.Grade = 'Enter Grade';
                }
                if (!data.travellercomment) {
                    errors.travellercomment = 'Enter Traveller Comment';
                }
                return errors;
            }
        },
        onSubmit: (data) => {
            setTravellerFormSubmit(false);
            saveUserTravelRecords(data);
        },
    });


    const isFormFieldValid = (name) =>
        !(searchForm.touched[name] && searchForm.errors[name]);
    const getFormErrorMessage = (name) => {
        return (
            isFormFieldValid(name) && (
                <small className="p-error">{searchForm.errors[name]}</small>
            )
        );
    };


    const saveUserTravelRecords = (data) => {
        userTravelRecords.next(data);
        dispatch(setTravelTab(1));
        // navigate('/TravelDetails');
    }
    return (
        <div className="tabview-demo tabview-forms">
            <form onSubmit={searchForm.handleSubmit} autoComplete='off'>
                <Panel>
                    <div className="formgrid grid">
                        <div className="field col-4 single-category">
                            <label htmlFor="Select Trip" className="font-bold block mb-2">Select Trip <span className={classNames({ "plt-Req p-error": isFormFieldValid("selectedTripType") })}></span></label>
                            <Dropdown
                                name="selectedTripType"
                                id="selectedTripType"
                                value={searchForm.values.selectedTripType}
                                options={tripTypes}
                                onChange={(e) => searchForm.setFieldValue('selectedTripType', e.value)}
                                // onChange={searchForm.handleChange}
                                placeholder="Select Trip"
                                className="w-100"
                            />
                            {getFormErrorMessage("selectedTripType")}
                        </div>

                        <div className="field col-4 single-category">
                            <label htmlFor="Select a Visa Type" className="font-bold block mb-2">Select a Visa Type</label>
                            <Dropdown
                                name="selectedVisaType"
                                value={searchForm.values.selectedVisaType}
                                options={visaTypes}
                                onChange={(e) => searchForm.setFieldValue('selectedVisaType', e.value)}
                                // onChange={searchForm.handleChange}
                                placeholder="Select a Visa Type"
                                className="w-100"
                            />
                            {getFormErrorMessage("selectedVisaType")}
                        </div>

                        <div className="field col-4 single-category">
                            <label htmlFor="User ECN " className="font-bold block mb-2">User ECN </label>
                            <InputText
                                name="userecn"
                                placeholder="User ECN"
                                value={searchForm.values.userecn}
                                onChange={searchForm.handleChange}
                                className="w-100"
                            />
                            {getFormErrorMessage("userecn")}
                        </div>

                        <div className="field col-4 single-category">
                            <label htmlFor="Manager ECN " className="font-bold block mb-2">Manager ECN </label>
                            <InputText
                                name="managerecn"
                                placeholder="Manager ECN"
                                value={searchForm.values.managerecn}
                                onChange={searchForm.handleChange}
                                className="w-100"
                            />
                            {getFormErrorMessage("managerecn")}
                        </div>

                        <div className="field col-4">
                            <label htmlFor="Traveller Name" className="font-bold block mb-2">Traveller Name</label>
                            <InputText
                                name="travellerName"
                                placeholder="Traveller Name"
                                value={searchForm.values.travellerName}
                                onChange={searchForm.handleChange}
                                className="w-100"
                            />
                            {getFormErrorMessage("travellerName")}
                        </div>

                        <div className="field col-4">
                            <label htmlFor="Traveller Initiated By (Proj Head)" className="font-bold block mb-2">Traveller Initiated By (Proj Head)</label>
                            <InputText
                                name="travellerInitiatedBy"
                                placeholder="Traveller Initiated By (Proj Head)"
                                value={searchForm.values.travellerInitiatedBy}
                                onChange={searchForm.handleChange}
                                className="w-100"
                            />
                            {getFormErrorMessage("travellerInitiatedBy")}
                        </div>

                        <div className="field col-4">
                            <label htmlFor="Surname" className="font-bold block mb-2">Surname</label>
                            <InputText
                                name="surname"
                                placeholder="Surname"
                                value={searchForm.values.surname}
                                onChange={searchForm.handleChange}
                                className="w-100"
                            />
                            {getFormErrorMessage("surname")}
                        </div>

                        <div className="field col-4">
                            <label htmlFor="Given Name" className="font-bold block mb-2">Given Name</label>
                            <InputText
                                name="givenName"
                                placeholder="Given Name"
                                value={searchForm.values.givenName}
                                onChange={searchForm.handleChange}
                                className="w-100"
                            />
                            {getFormErrorMessage("givenName")}
                        </div>

                        <div className="field col-4 single-category">
                            <label htmlFor="Select a Designation" className="font-bold block mb-2">Designation</label>
                            <Dropdown
                                name="selectedDesignation"
                                value={searchForm.values.selectedDesignation}
                                options={designation}
                                onChange={(e) => searchForm.setFieldValue('selectedDesignation', e.value)}
                                // onChange={searchForm.handleChange}
                                placeholder="Select a Designation"
                                className="w-100"
                            />
                            {getFormErrorMessage("selectedDesignation")}
                        </div>

                        <div className="field col-4">
                            <label htmlFor="Mobile Number" className="font-bold block mb-2">Mobile Number</label>
                            <InputText
                                type="tel"
                                name="mobileNumber"
                                placeholder="Mobile Number"
                                value={searchForm.values.mobileNumber}
                                onChange={searchForm.handleChange}
                                className="w-100"
                            />
                            {getFormErrorMessage("mobileNumber")}
                        </div>

                        <div className="field col-4">
                            <label htmlFor="Email ID" className="font-bold block mb-2">Email ID</label>
                            <InputText
                                type="email"
                                name="emailId"
                                placeholder="Email ID"
                                value={searchForm.values.emailId}
                                onChange={searchForm.handleChange}
                                className="w-100"
                            />
                            {getFormErrorMessage("emailId")}
                        </div>

                        <div className="field col-4">
                            <label htmlFor="Mobile Number" className="font-bold block mb-2">Grade</label>
                            <InputText
                                type="text"
                                name="Grade"
                                placeholder="Enter Grade"
                                value={searchForm.values.Grade}
                                onChange={searchForm.handleChange}
                                className="w-100"
                            />
                            {getFormErrorMessage("Grade")}
                        </div>

                        <div className="field col-4">
                            <label htmlFor="travellercomment" className="font-bold block mb-2">Traveller comment</label>
                            <InputTextarea
                                name="travellercomment"
                                placeholder="Enter Travellercomment"
                                value={searchForm.values.travellercomment}
                                onChange={searchForm.handleChange}
                                className="w-100"

                            />
                            {getFormErrorMessage("travellercomment")}
                        </div>
                    </div>
                </Panel>

                <Panel>
                    <div className="formgrid grid">
                        <div className="field col-12 card flex flex-wrap gap-3">
                            <Button label="Save as draft " icon="pi pi-inbox" aria-label="Save" severity="primary" type='submit' onClick={() => setTravellerFormSubmit(true)} />
                            <Button label="Save & Next" aria-label="Save" severity="success" type='submit' icon="pi pi-save" onClick={() => setTravellerFormSubmit(true)} />
                        </div>
                    </div>
                </Panel>
            </form>
            <Panel>
                <TravelDataTable />
            </Panel>
        </div>
    );
}

export default TravellerDetails;
